import { PlusIcon, StarIcon } from '@phosphor-icons/react';
import classNames from '@utils/classnames';
import * as Dialog from '@radix-ui/react-dialog';

import { DataField } from '../../../components/DataField';
import { useState } from 'react';
import { rateOrder } from '../models';
import { RatingInput } from './RatingInput';
import { Button } from '../../../components/button/Button';
import toast from 'react-hot-toast';
import { getDisplayError } from '../../../utils/get-display-error';
import { captureException } from '@sentry/react';

export interface IRatingDatafieldProps {
  order: {
    id: string;
    rating: number;
  };
  // Revalidate the order data after a successful rating. The internal order
  // page and the customer portal each pass their own refresh (SWR mutate /
  // urql refetch) — the urql document-cache used to do this implicitly.
  onRated?: () => void | Promise<void>;
}

export const RatingDatafield: React.FC<IRatingDatafieldProps> = (props) => {
  const { order, onRated } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [isRating, setIsRating] = useState(false);
  const [newRating, setNewRating] = useState(order.rating);

  return (
    <DataField title="Rating">
      <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
        <Dialog.Trigger asChild disabled={isRating}>
          <div className="flex cursor-pointer">
            {new Array(5).fill('').map((_v, idx) => {
              return (
                <StarIcon
                  className={classNames('w-4 h-4', {
                    'text-brand-text fill-brand': idx < order.rating,
                    'text-fg-muted': idx >= order.rating,
                  })}
                  key={`${order.id}-${idx}`}
                />
              );
            })}
          </div>
        </Dialog.Trigger>

        <Dialog.Portal>
          <Dialog.Overlay className="dialog-overlay" />
          <Dialog.Content className="dialog-content">
            <Dialog.Title className="heading-one mb-4">Rate Order</Dialog.Title>

            <RatingInput value={newRating} onChange={setNewRating} />

            <div className="mt-8">
              <Button
                color="primary"
                iconLeft={<PlusIcon className="button-icon" />}
                onTrigger={async () => {
                  setIsRating(true);
                  try {
                    await rateOrder(order.id, newRating);
                    toast.success('Rating aangepast');
                    setIsOpen(false);
                    await onRated?.();
                  } catch (err) {
                    captureException(err);
                    toast.error('Kon rating niet aanpassen: ' + getDisplayError(err));
                  } finally {
                    setIsRating(false);
                  }
                }}
              >
                Pas rating aan
              </Button>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </DataField>
  );
};
